import { DataBean } from "../DataBean";

export class HelpDesk extends DataBean {

    public OPEN = 1;
    public ASIGNADO = 2;
    public CLOSE = 3;
    public DELETE =0;
       
    public async getHelpDeskRender(page:number,rows:number,props:any): Promise<any> {
        return this.getCustomService("ProcessFlow", "com.advantage.shared.Report_getHelpDeskRender_Number_Number_java.util.Map", [
            page,rows,props
        ]);
    }
   
  
  
   
}
